/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/Note"
  
}) {
  return null
}